// tslint:disable:object-literal-sort-keys
import React, { useState } from "react";

import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";

import * as _ from "lodash";

import CustomSelect from "./custom-select";

import FormattedNodeRow from "./components/formatted-node-row";

import { nodes as filterNodes } from "./agutils";
import { NodeClasses } from "./NodeClasses";

// import { theme as innerTheme } from "./small-table-theme";

// // TODO where to sort? here or in flatten?
// const getChildRows = (row: any, rows: any[]) => {
//   const childRows = rows.filter((r) => (row ? r.parent === row.id : !r.parent)); // TODO parent vs. parentId
//   return childRows.length ? _.sortBy(childRows, "displayName") : null;
//   // return row && row.children ? row.children : null;
// };

interface Props {
  name: string;
  label?: string;
  nodes: any; // TODO is nodes not an array?
  showId?: boolean;
  value?: any;
  onChange: (event: React.ChangeEvent<any> | any) => void;
  nodeClasses?: NodeClasses[];
  required?: boolean;
  supportDefault?: boolean;
}

// TODO Material Design
function PanelSelect(props: Props) {
  const {
    name,
    label,
    nodes,
    // showId = false,
    value: oldValue,
    onChange,
    nodeClasses = [],
    required,
    supportDefault = false,
  } = props;
  // const classes = useStyles(props);

  // TODO remove flattended (not needed for TreeView)
  function flattened(node: any): any[] {
    if (!node.children) {
      return [];
    }
    return [node, ..._.flatMap(node.children, (n) => flattened(n))];
  }

  const mapNode = (node: any) => {
    // const id = `${node.id}`;
    return {
      ...node,
      name: node.displayName,
      children: node.children ? node.children.map((n: any) => mapNode(n)) : [],
    };
  };

  const [search, setSearch] = useState("");

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const handleNodeToggle = (
    event: React.ChangeEvent<{}>,
    nodeIds: string[]
  ) => {
    setExpanded(nodeIds);
  };

  // tree selection
  // const [selected, setSelected] = useState<string>(oldValue);
  const handleSelect = (event: React.ChangeEvent<{}>, nodeIds: string) => {
    // if (!nodeIds.startsWith("category_")) {
    //   setSelected(nodeIds);
    //   onChange(nodeIds); // TODO currentSelected
    //   // TODO handleClose?
    // }

    // single select, see https://github.com/DevExpress/devextreme-reactive/issues/477
    // const lastSelected = changedSelection.find(
    //   (selected) => newSelection.indexOf(selected) === -1
    // );
    const lastSelected = nodeIds;
    // TODO How to avoid selection?
    if (
      lastSelected !== undefined &&
      (!nodeClasses ||
        nodeClasses.length === 0 ||
        nodeClasses.includes(
          NodeClasses[
            // rows[lastSelected as number]
            rows.find((row) => `n_${row.id}` === lastSelected)
              ?.nodeClassName as keyof typeof NodeClasses
          ]
        ))
      // rows[lastSelected as number].__typename !== "AreaNode"
    ) {
      // setSelected(lastSelected);
      setNewSelection([lastSelected]);
    }
  };

  // console.log("got nodes ", nodes);
  // TODO is nodes not an array?
  const filteredNodes =
    nodes && ((nodeClasses && nodeClasses.length > 0) || search.length > 0)
      ? filterNodes(nodes, nodeClasses, search)
      : nodes;
  const data =
    filteredNodes &&
    flattened([filteredNodes].map((node: any) => mapNode(node))[0]); // mapNode is for name vs. displayNode
  // const data = nodes && flattened(nodes).map(node => mapNode(node));
  // const data = nodes && [nodes].map(node => mapNode(node));
  // console.log("after got nodes ", data);

  // const columns = [
  //   // { name: "formatted", title: " " },
  //   { name: "name", title: "Name" },
  // ];
  // const [tableColumnExtensions, setTableColumnExtensions] = useState([
  //   { columnName: "name", width: 1024 }
  // ]);

  // const allRowIds = data.map((content: any, i: number) => i);
  const allRowIds = data
    .filter((node: any) => node.children && node.children.length > 0)
    .map((node: any) => `n_${node.id}`);
  const rows = data;

  const [selection, setSelection] = useState(
    oldValue ? [`n_${oldValue}`] : ([] as Array<string>)
  );
  const [expanded, setExpanded] = useState(allRowIds /*[] as Array<string>*/);
  const [newSelection, setNewSelection] = useState(selection);
  // const [anchorEl, setAnchorEl] = useState(null);
  // console.log("old value", selection);

  // // BEGIN get tree recursively
  // const { data, error, loading } = useQuery(GetAllNodes, {});
  // if (loading) {
  //   return <div>Loading...</div>;
  // }
  // if (error) {
  //   console.error(error);
  //   return <p>Error :(</p>;
  // }
  // // data.nodes
  // // TODO see "const filteredNodes"
  // const nodes = data.nodes;
  // setExpanded(nodes.map((node: any) => `n_${node.id}`));

  // // TODO Now the most important part
  // // Try do code as hook
  // // - for all expanded
  // //   get nodes to update cache INCLUDING the node with children attribute (so that the cache now has a new node with children set)
  // // get root node again now including children => continue with "filteredNodes"

  // // const filteredNodes =
  // // nodes && ((nodeClasses && nodeClasses.length > 0) || search.length > 0)
  // //   ? filterNodes(nodes, nodeClasses, search)
  // //   : nodes;
  // // const data =
  // //   filteredNodes &&
  // //   flattened([filteredNodes].map((node: any) => mapNode(node))[0]); // mapNode is for name vs. displayNode

  // // END get tree recursively

  // const rows = dataSource.map((content: any) => {
  //   return { ...content, formatted: content };
  // });
  // const selectedNodeIds = selection.map(s => dataSource[(s as number)].id);
  // const nodesSelected = selectedNodeIds.length > 0;

  // const selectedNodeIdsString = selectedNodeIds.join(',');

  // console.log("selected row: ", rows[selection[0] as number]);

  function mapNodesToTreeItems(nodes: any) {
    // const filtered = nodes; // TODO filter
    // TODO use filteredNodes directly?
    const filtered = nodes;
    return _.sortBy(
      filtered /*.filter((node: any) => node.category === category)*/,
      "displayName"
    ).map((node: any) => (
      // TODO only show if nodes exist
      <TreeItem
        key={`n_${node.id}`}
        nodeId={`n_${node.id}`}
        label={
          <div
          // className={classes.labelRoot}
          >
            {/* <LabelIcon color="inherit" className={classes.labelIcon} />
            <Typography variant="body2"
              // className={classes.labelText}
            >
              {node.displayName}
            </Typography>
            <Typography variant="caption" color="inherit">
              {node.id}
            </Typography> */}
            <FormattedNodeRow
              value={{ ...node, name: node.displayName }}
              showId={true}
            />
          </div>
        }
      >
        {node.children && mapNodesToTreeItems(node.children)}
      </TreeItem>
    ));
  }

  console.log(
    "current value is ",
    selection[0],
    selection[0]
      ? rows.find((row) => `n_${row.id}` === selection[0])
      : undefined
  );

  return (
    <CustomSelect
      name={name}
      label={label}
      itemToString={
        (value) => (!_.isNil(value) ? value.displayName : "") // (!!supportDefault ? "Default" : "")
      }
      value={
        selection[0]
          ? rows.find((row) => `n_${row.id}` === selection[0])
          : undefined
      }
      onAccept={(v: any) => {
        if (v !== null) {
          setSelection(newSelection);
          onChange(newSelection[0] ? newSelection[0].substring(2) : undefined);
        } else {
          setNewSelection([]);
          setSelection([]);
          onChange(undefined);
        }
      }}
      required={required}
      supportDefault={supportDefault}
    >
      <TextField
        // label="Search"
        placeholder="Search…"
        value={search}
        onChange={handleSearchChange}
        fullWidth
        autoFocus
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          "aria-label": "Search",
        }}
      />
      <div style={{ width: "1024px" }}>
        <TreeView
          expanded={expanded}
          // defaultExpanded={[`category_${currentSelected.category}`]}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          defaultEndIcon={<div style={{ width: 24 }} />}
          // selected={selected}
          selected={newSelection[0]}
          onNodeSelect={handleSelect}
          onNodeToggle={handleNodeToggle}
          // style={{ padding: "8px", maxHeight: "75vh" }} // TODO use theme.spacing
        >
          {filteredNodes && mapNodesToTreeItems([filteredNodes])}
        </TreeView>

        {/* <Grid rows={rows} columns={columns}>
            <DataTypeProvider
              formatterComponent={({ row, value }) => (
                <FormattedNodeRow value={row} showId={true} />
              )}
              for={["name"]}
            />

            <SelectionState
              selection={newSelection}
              onSelectionChange={(changedSelection) => {
                // single select, see https://github.com/DevExpress/devextreme-reactive/issues/477
                const lastSelected = changedSelection.find(
                  (selected) => newSelection.indexOf(selected) === -1
                );
                // TODO How to avoid selection?
                if (
                  lastSelected !== undefined &&
                  (!nodeClasses ||
                    nodeClasses.length === 0 ||
                    nodeClasses.includes(
                      NodeClasses[
                        rows[lastSelected as number]
                          .nodeClassName as keyof typeof NodeClasses
                      ]
                    ))
                  // rows[lastSelected as number].__typename !== "AreaNode"
                ) {
                  setNewSelection([lastSelected]);
                }
              }} // setSelection(changedSelection)
            />

            <TreeDataState defaultExpandedRowIds={allRowIds} />

            <CustomTreeData getChildRows={getChildRows} />

            <Table
            // columnExtensions={tableColumnExtensions}
            />
            <TableTreeColumn
              for="name"
              // showSelectionControls
            />
            <TableSelection
              selectByRowClick
              highlightRow
              showSelectionColumn={false}
            />
          </Grid> */}
      </div>
    </CustomSelect>
  );
}

export default PanelSelect;
